<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            Виконавець
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Employee"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text>
            <v-row>
              <v-col cols="6" class="py-0">
                <CustomTextField
                  v-model="title"
                  label="ПІБ співробітника TQM systems"
                  class="ml-1"
                  @input="isChanged = true"
                />
              </v-col>
              <v-col cols="6" class="py-0">
                <CustomTextField
                  v-model="email"
                  label="Email співробітника TQM systems"
                  class="ml-1"
                  @input="isChanged = true"
                />
              </v-col>
              <v-col cols="6" class="pt-2">
                <DepartmentSelect
                  v-model="department"
                  class="ml-1"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-tabs v-model="tab">
                  <v-tab>Грейди</v-tab>
                  <v-tab>Клієнти</v-tab>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <v-toolbar flat color="white">
                        <v-tooltip
                          left
                          nudge-top="30"
                          nudge-right="255"
                          :open-delay="500"
                          color="#388e3c"
                        >
                          <template v-slot:activator="{ on }">
                            <v-toolbar-title class="helper mr-2 pa-0" v-on="on">
                              Грейди
                            </v-toolbar-title>
                          </template>
                          <span>Історія зміни рівня грейда співробітника</span>
                        </v-tooltip>

                        <v-btn
                          :disabled="gradeEditMode"
                          class="ma-1"
                          small
                          @click="addGrade"
                        >
                          Додати
                        </v-btn>
                      </v-toolbar>
                      <v-data-table
                        :headers="gradesHeaders"
                        :items="grades"
                        sort-by="startFrom"
                        must-sort
                        :sort-desc="true"
                        :hide-default-footer="grades.length < 11"
                      >
                        <template v-slot:header="{ props: { headers } }">
                          <v-tooltip
                            v-if="headers.tooltip"
                            top
                            :open-delay="500"
                            color="#388e3c"
                          >
                            <template v-slot:activator="{ on }">
                              <span class="helper" v-on="on">
                                {{ headers.text }}
                              </span>
                            </template>
                            <span>
                              {{ headers.tooltip }}
                            </span>
                          </v-tooltip>
                        </template>
                        <template v-slot:item="{ item }">
                          <GradeEditor
                            v-if="item.editMode"
                            slot="input"
                            :grade-item="{ ...item }"
                            @apply="applyGradeEdit"
                            @cancel="cancelGradeEdit"
                          />
                          <tr v-else>
                            <td>
                              {{ item.startFrom | date }}
                            </td>
                            <td>
                              {{ item.project ? item.project.title : "" }}
                            </td>
                            <td>
                              {{ item.value | emptyNumber }}
                            </td>
                            <td class="justify-end align-center d-flex px-1">
                              <v-btn
                                :disabled="gradeEditMode"
                                icon
                                class="mx-0"
                                @click="enableGradeEdit(item)"
                              >
                                <v-icon color="grey">
                                  edit
                                </v-icon>
                              </v-btn>
                              <v-btn
                                :disabled="gradeEditMode"
                                icon
                                class="mx-0"
                                @click="removeGrade(item)"
                              >
                                <v-icon color="grey">
                                  delete_outline
                                </v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-btn
                        :disabled="clientEditMode"
                        class="ma-1"
                        small
                        @click="enableClientEdit"
                      >
                        Назначити клієнту
                      </v-btn>
                      <ClientSelectEditor
                        v-if="clientEditMode"
                        @apply="addClientsAnalyst"
                        @cancel="cancelClientsAnalystEdit"
                      />
                      <v-data-table
                        fixed-header
                        height="425"
                        :headers="clientHeaders"
                        :items="clientsAnalyst"
                        :hide-default-footer="clientsAnalyst.length < 11"
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td>
                              {{ item.title }}
                            </td>
                            <td class="justify-end align-center d-flex px-1">
                              <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    class="mx-0"
                                    v-on="on"
                                    @click="
                                      removeClientsAnalystFromEmployee(item.id)
                                    "
                                  >
                                    <v-icon color="grey">
                                      mdi-account-off
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Відв'язати виконавця від клієнта.</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              class="primary-button"
              :loading="loading"
              :disabled="!isChanged"
              @click="save"
            >
              Зберегти
            </v-btn>
            <ModalLoader title="Зміни зберігаються" :loading="loading" />
            <v-btn v-if="!modal" @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import GradeEditor from "./GradeEditor.vue";
import * as employeeApi from "../../../backend/employeesApi.js";
import ModalLoader from "../../../components/ModalLoader.vue";
import ClientSelectEditor from "./ClientSelectEditor.vue";
import DepartmentSelect from "../departments/DepartmentSelect.vue";

export default {
  components: {
    GradeEditor,
    ModalLoader,
    ClientSelectEditor,
    DepartmentSelect,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    tab: "",
    loading: false,
    gradesHeaders: [
      {
        text: "Дата",
        tooltip: "Дата, з якої діє відповідний Грейд",
        value: "startFrom",
        sortable: true,
      },
      {
        text: "Проект",
        tooltip: "Проект, для якого діє відповідний Грейд",
        sortable: false,
      },
      {
        text: "Грейд",
        tooltip:
          "Коефіцієнт перерахунку від базового тарифу вартості години Послуг",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
      },
    ],
    clientHeaders: [
      {
        text: "Клієнт",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
      },
    ],
    grades: [],
    clientEditMode: false,
    clientsAnalyst: [],
    pagination: {
      descending: true,
      sortBy: "startFrom",
      rowsPerPage: -1,
    },
    isNew: true,
    isChanged: false,
    email: "",
    department: null,
  }),
  computed: {
    gradeEditMode() {
      return this.grades.filter((g) => g.editMode === true).length !== 0;
    },
  },
  created() {
    employeeApi.getEmployee(this.id).then((employee) => {
      this.title = employee.title;
      this.grades = employee.grades;
      this.clientsAnalyst = employee.clientsAnalyst;
      this.email = employee.email;
      this.department = employee.department;
    });
  },
  methods: {
    async save() {
      this.loading = true;
      await employeeApi.updateEmployee(this.id, {
        title: this.title,
        grades: this.grades.map((g) => {
          return {
            startFrom: g.startFrom,
            projectId: g?.project?.id || null,
            value: g.value,
          };
        }),
        email: this.email,
        departmentId: this.department?.id || null,
      });
      this.isChanged = false;
      this.loading = false;
    },
    addGrade() {
      this.isChanged = true;
      this.grades.unshift({
        startFrom: this.moment(Date.now()).format("YYYY-MM-DD"),
        value: 0,
        isNew: true,
        editMode: true,
      });
    },
    enableGradeEdit(grade) {
      grade.editMode = true;
      this.isChanged = true;
    },
    applyGradeEdit(grade) {
      const editedGrade = this.grades.find((g) => g.editMode);
      editedGrade.value = grade.value;
      editedGrade.startFrom = grade.startFrom;
      editedGrade.project = grade.project;
      editedGrade.editMode = false;
      editedGrade.isNew = false;
      this.isChanged = true;
    },
    cancelGradeEdit(isNew) {
      if (isNew) {
        const editedGrade = this.grades.find((g) => g.isNew);
        this.grades.splice(this.grades.indexOf(editedGrade), 1);
      } else {
        const editedGrade = this.grades.find((g) => g.editMode);
        editedGrade.editMode = false;
      }
    },
    removeGrade(item) {
      this.grades.splice(this.grades.indexOf(item), 1);
      this.isChanged = true;
    },
    enableClientEdit() {
      this.isChanged = true;
      this.clientEditMode = true;
    },
    async addClientsAnalyst(clients) {
      if (!clients.length) {
        return;
      }
      this.loading = true;
      for (let i = 0; i < clients.length; i++) {
        await employeeApi.addEmployeeToClient(clients[i].id, this.id);
        this.clientsAnalyst.splice(0, 0, clients[i]);
      }
      this.clientEditMode = false;
      this.isChanged = false;
      this.loading = false;
    },
    cancelClientsAnalystEdit() {
      this.clientEditMode = false;
    },
    async removeClientsAnalystFromEmployee(id) {
      if (!id) {
        return;
      }
      this.loading = true;
      await employeeApi.removeClientsAnalystFromEmployee(id);
      for (let i = 0; i < this.clientsAnalyst.length; i++) {
        if (this.clientsAnalyst[i].id == id) {
          this.clientsAnalyst.splice(i, 1);
        }
      }
      this.isChanged = false;
      this.loading = false;
    },
  },
};
</script>

<style>
.helper,
.helper
  .CustomTextField
  > .v-input__control
  > .v-input__slot
  > .CustomTextField__slot
  > input {
  cursor: help;
}
.v-input__prepend-outer .v-icon {
  color: #bdbdbd;
}
/* */
.v-data-table__wrapper .v-input .v-text-field__details {
  position: absolute;
  width: 100%;
  text-align: left;
  background: #fff;
  padding: 3px 5px;
  margin: 0px;
  bottom: -18px;
  border: solid 2px;
}
@media screen and (max-width: 1919px) {
  .v-data-table__wrapper .v-input .v-text-field__details {
    position: absolute;
    width: 100%;
    text-align: left;
    background: #fff;
    padding: 3px 5px;
    margin: 0px;
    bottom: -27px;
    border: solid 2px;
  }
}
</style>
